import awsmobile from './amplifyconfiguration.json';

export const awsConfig = {
    awsmobile: {
        ...awsmobile,
        Analytics: {
            ...(awsmobile.Analytics ?? {}),
            KinesisFirehose: {
                region: awsmobile.aws_project_region
            }
        }
    },
    analytics: {
        firehoseStreamName: 'pole-journal-analytics'
    },
    restApi: {
        name: 'PoleJournalRest'
    }
};

export const awsAnalyticsConfig = {
    Analytics: awsConfig.awsmobile.Analytics
};
